import { Box, Button, Theme, Typography } from '@mui/material'
import styled from 'styled-components'

export const Background = styled(Box)<{
  theme: Theme
  background?: 'dark' | 'light'
}>`
  height: 150px;
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: ${({ theme, background = 'light' }) =>
    background === 'dark'
      ? theme.palette.secondary.light
      : theme.palette.common.white};
`

export const Container = styled(Box)`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`

export const LeftContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const TextContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
`

export const SettingsText = styled(Typography)<{ variant?: 'light' | 'bold' }>`
  font-weight: ${({ variant = 'light' }) =>
    variant === 'light' ? '300 !important' : '700 !important'};
  font-size: 15px !important;
`

export const SettingsButton = styled(Button)`
  min-width: 200px !important;
  border-radius: 5px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 15px !important;
  height: 36px !important;
`
